define('controllers/fieldRepeater',[ 'models/fieldRepeaterSetCollection', 'models/fieldCollection', 'models/fieldRepeaterTemplateFields' ], function( repeaterSetCollection, fieldCollection, cloneTemplateFields ) {
    var controller = Marionette.Object.extend({

        initialize: function () {
            this.listenTo( nfRadio.channel( 'repeater' ), 'init:model', this.initRepeater );
        },

        initRepeater: function ( model ) {
        	if ( 'undefined' == typeof model.collection.options.formModel ) {
        		return false;
        	}

        	// Ensure every sub-field has a key for data-testid rendering
        	var subFields = model.get( 'fields' );
        	if ( subFields && subFields.length ) {
        		_.each( subFields, function( field ) {
        			if ( ! field.key || '' === String( field.key ).trim() ) {
        				var d = new Date();
        				field.key = ( field.type || 'field' ) + '_' + d.valueOf();
        			}
        		});
        	}

        	// Give the first fieldset its own copy so rendering it cannot write the
        	// visitor's answers back onto the template every later fieldset is built from.
        	let fields = new fieldCollection( cloneTemplateFields( subFields ), { formModel: model.collection.options.formModel, repeaterFieldModel: model } );
            model.set( 'sets', new repeaterSetCollection( [ { fields: fields } ], { templateFields: cloneTemplateFields( subFields ), formModel: model.collection.options.formModel, repeaterFieldModel: model } ) );
            //Trigger Fields IDs sorting in case of same form being printed multiple times on DOM
            nfRadio.channel( "field-repeater" ).trigger( 'sort:fieldsets' );
        },

    });

    return controller;
});
